import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column cadre1" }
const _hoisted_2 = { class: "cadre3 d-flex flex-column gap-3" }
const _hoisted_3 = { id: "dccloudpage" }
const _hoisted_4 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_5 = { class: "d-flex flex-row justify-content-center mt-3 mb-3" }
const _hoisted_6 = { class: "d-flex flex-row cadrechecks" }
const _hoisted_7 = { class: "form-check checkbox-xl" }
const _hoisted_8 = {
  class: "form-check-label",
  for: "checktous"
}
const _hoisted_9 = { class: "form-check checkbox-xl" }
const _hoisted_10 = {
  class: "form-check-label",
  for: "checkaucun"
}
const _hoisted_11 = { class: "d-flex flex-column gap-3" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex flex-column gap-3 pcline"
}
const _hoisted_13 = { class: "d-flex flex-row gap-3 align-items-center" }
const _hoisted_14 = { class: "form-check checkbox-xl flex-grow-1" }
const _hoisted_15 = ["id", "disabled", "value"]
const _hoisted_16 = ["for"]
const _hoisted_17 = { class: "versioninstalled" }
const _hoisted_18 = { class: "d-flex flex-column gap-2" }
const _hoisted_19 = { class: "progress" }
const _hoisted_20 = ["aria-valuenow"]
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-row justify-content-center"
}
const _hoisted_22 = { class: "d-flex flex-row justify-content-center align-items-center mt-2 gap-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "mt-2 d-flex flex-row justify-content-center" }
const _hoisted_31 = ["href", "disabled"]
const _hoisted_32 = {
  key: 1,
  class: "mt-3 d-flex flex-row justify-content-end align-items-center"
}
const _hoisted_33 = { class: "connectmsgagentnotinstalled" }
const _hoisted_34 = {
  key: 2,
  class: "mt-3 d-flex flex-row justify-content-end align-items-center"
}
const _hoisted_35 = { class: "connectmsgagentnotinstalled" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, null, -1 /* HOISTED */)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 4,
  class: "mb-3"
}
const _hoisted_40 = { key: 5 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "d-flex flex-row" }
const _hoisted_43 = { class: "hostname flex-grow-1" }
const _hoisted_44 = { class: "versionnotinstalled" }

import customProtocolCheck from "custom-protocol-check";
    import { ref, Ref, onMounted, watch , computed} from 'vue';
    import axios, { AxiosResponse } from 'axios';
    import { useSignalR } from './../../../../Scripts/js/signalrmonitoring.service';
    import { ProgressApp, TaskEnd } from './../../../../Scripts/js/SignalReceiver';
    import { MCRedirectSubmitUrl, AppCloudAction, ChangeLangueActionData, DetectActionData, DriversInstallActionData, RestorePointActionData, BackupAllDriverActionData, MonitoringActionData, WebSocketIndex } from './../../../Shared/AppCloudModel';
    import { InstallAppApiViewModel } from '../../../../Views/startdetection/index';
    import * as bootstrap from "bootstrap";

    enum ProtocolHandlerStatus { Installed = 0, NotInstalled = 1, NoSupport = 2}
export default /*#__PURE__*/_defineComponent({
  __name: 'DcappcloudComponent',
  props: {
    isconnect: { type: Boolean },
    lan: {},
    authuserurl: {},
    urlconfig: {},
    urlconfigauth: {},
    urlmonitor: {},
    action: {},
    service: {},
    dcappcloud_desc: {},
    dcappcloud_all: {},
    dcappcloud_none: {},
    dcappcloud_installedagent: {},
    dcappcloud_but_startdetect: {},
    dcappcloud_but_terminatedetect: {},
    dcappcloud_but_installdrivers: {},
    dcappcloud_but_createrestorepoint: {},
    dcappcloud_but_savealldrivers: {},
    dcappcloud_but_startmonitoring: {},
    dcappcloud_but_stopmonitoring: {},
    dcappcloud_but_connect: {},
    dcappcloud_desc_connect: {},
    dcappcloud_emptyconnectedlist_notconnect: {},
    dcappcloud_emptyconnectedlist_connect: {},
    dcappcloud_listconnected: {},
    dcappcloud_noinstalledagent: {},
    dcappcloud_agent_errconnect_notinstalled: {},
    dcappcloud_agent_errconnect_nosupport: {}
  },
  setup(__props: any) {

    ;
    const signalrhub = useSignalR();
    const props = __props;
    const listeconnected: Ref<WebSocketIndex[]> = ref([]);
    const viewappli: Ref<InstallAppApiViewModel | null> = ref(null);
    const dc_descpilotesreferer: Ref<string | null> = ref(null);
    let isdetect: Ref<boolean> = ref(false);
    const actioncurrent: Ref<AppCloudAction> = ref(props.action);
    const servicecurrent: Ref<MCRedirectSubmitUrl> = ref(props.service);
    const lan: Ref<string> = ref(props.lan);
    let mapmachineprogress: Ref<Map<string, ProgressApp>> = ref(new Map<string, ProgressApp>());
    let authuserurl: Ref<string> = ref(props.authuserurl);
    const pccheck: Ref<string[]> = ref([]);
    const checkall: Ref<boolean> = ref(false);
    const checknone: Ref<boolean> = ref(true);
    const numDetectConfig: Ref<number> = ref(0);
    const mustDetectHostname: Ref<string[]> = ref([]);
    const isAgentInstalled: Ref<ProtocolHandlerStatus> = ref(ProtocolHandlerStatus.Installed);
    const lastConfigTerminated: Ref<string> = ref("");
    const isDownHostname: Ref<string[]> = ref([]);

    watch(pccheck, async (newPCCheck: string[], oldPCCheck: string[]) => {
        if (newPCCheck.length == 0) {
            checknone.value = true;
            checkall.value = false;
        }
        else if (newPCCheck.length == listeconnected.value.filter(m => m.isconnect).length) {
            checknone.value = false;
            checkall.value = true;
        }
    },
        { deep: true });

        watch(() => props.action, (newAction: AppCloudAction) => {
  actioncurrent.value = newAction;
});

        watch(() => props.service, (newService: MCRedirectSubmitUrl) => {
  servicecurrent.value = newService;
});

        const hasConfigConnected = computed(() => {
  return NumConfigConnected()>0;
        });

    const hasTerminateDetection = computed(() => {
        return numDetectConfig.value >= 1 && pccheck.value.length !== numDetectConfig.value;
    });

    onMounted(async () => {
        lan.value = props.lan;
        authuserurl.value = props.authuserurl;
        console.log("onmounted dcappcloud");
        await signalrhub.init();
        await JoinGroupByUser();
        signalrhub.on("SendProgressApp", (data: ProgressApp) => {
            SendProgressApp(data);
        });
         signalrhub.on("TaskEnd", (data: TaskEnd) => {
       isdetect.value = false;
        });
        signalrhub.on("ReconnectApp", async (hostname: string, isConnect: boolean) => {
            if (!isConnect) {
                numDetectConfig.value = numDetectConfig.value <= 0 ? 0 : numDetectConfig.value--;
                
                if (isDownHostname.value.indexOf(hostname)<0)
                    isDownHostname.value.push(hostname);
            }
            else {
                if (isDownHostname.value.indexOf(hostname)>=0)
                    isDownHostname.value= isDownHostname.value.filter(h => h != hostname);
            }
            console.log("ReconnectApp", hostname, isConnect);
            await RegisterPC();
            await GetListeConnected();
        });
        signalrhub.on("OpenConfigApp", (idconfig: string, authuser: string, hostname: string, service: MCRedirectSubmitUrl) => {
            OpenConfigApp(idconfig, authuser, hostname, service);
        });
        signalrhub.on("OpenMonitorApp", (idconfig: string) => {
            OpenMonitorApp(idconfig);
        });
        signalrhub.on("DCPing", async (userid: number, hostname: string) => {
            await DCPing(userid, hostname);
        });
        signalrhub.on("UpdateAgentNotification", async (hostname: string) => {
            console.log("UpdateAgentNotification " + hostname);
            if (mustDetectHostname.value.indexOf(hostname)<0)
            mustDetectHostname.value.push( hostname);
        });
        
        await RegisterPC();
        await GetListeConnected();
    });

    function DCConnect() {
        const url = jQuery("#dcconnectbut").attr("href");
        if (url == null)
            return;

        isdetect.value = true;
       
        customProtocolCheck(
            url ,
            () => {
                isdetect.value = false;
                isAgentInstalled.value = ProtocolHandlerStatus.NotInstalled;
            },
            () => {
                isdetect.value = false;
                isAgentInstalled.value = ProtocolHandlerStatus.Installed;
            },
            2000,
            () => {
                isdetect.value = false;
                isAgentInstalled.value = ProtocolHandlerStatus.NoSupport;
            }
        );
        return false;
    }

    function SetCheckAll(event: any) {
        if (!event.target.value)
            return;
        pccheck.value = [];
        for (const pc of listeconnected.value) {
            if (pc.isconnect) {
                pccheck.value.push(pc.hostname);
            }
        }
    }

    function SetCheckNone(event:any) {
        if (!event.target.value)
            return;
        pccheck.value = [];
    }

    function GetProgressPourcentage(hostname: string) {
        return (mapmachineprogress.value.has(hostname) ? (mapmachineprogress.value.get(hostname) as ProgressApp).pourcentage : 0);
    }

    function GetProgressDesc(hostname: string) {
        return mapmachineprogress.value.has(hostname) ? (mapmachineprogress.value.get(hostname) as ProgressApp).text : "";
    }

    async function DCPing(userid: number, hostname: string) {
        console.log("DCPing " + userid + " " + hostname);
        let findindex: WebSocketIndex | undefined = listeconnected.value.find(m => m.hostname == hostname && m.userid == userid);
        if (findindex != undefined) {
            findindex.signalrid = signalrhub.GetConnectionID();
            findindex.isconnect = true;
            await ChangeLangue(hostname, lan.value);
            if (pccheck.value.indexOf(hostname)===-1)
                pccheck.value.push(hostname);
        }
        if ((mustDetectHostname.value.indexOf( hostname)>=0) && isDownHostname.value.indexOf(hostname)<0) {
            await LaunchDetectionAux([hostname]);
            mustDetectHostname.value = mustDetectHostname.value.filter(h => h != hostname);
        }
    }

    function NumConfigConnected(): number {
        return listeconnected.value.filter(m => m.isconnect).length;
    }

    function SendProgressApp(data: ProgressApp) {
        console.log("data:" + data.pourcentage + " " + data.text);
        mapmachineprogress.value.set(data.hostname, data);
    }

    function TerminateDetection() {
        if (lastConfigTerminated.value !== "") {
            location.href = lastConfigTerminated.value;
        }
    }

    function OpenConfigApp(idconfig: string, authuser: string, hostname: string, service: MCRedirectSubmitUrl) {
        console.log("idconfig:" + idconfig, numDetectConfig.value, pccheck.value.length);
        numDetectConfig.value++;
        let urldst: string = "";
        if (authuser != "")
            urldst = props.urlconfigauth.replace("%authuser%", authuser).replace("%service%", (service as number).toString());
        else
            urldst = props.urlconfig.replace("%idconfig%", idconfig).replace("%service%", (service as number).toString());
        if (pccheck.value.length == numDetectConfig.value) {
            location.href = urldst;
        }
        else {
            lastConfigTerminated.value = urldst;
            let findindex: WebSocketIndex | undefined = listeconnected.value.find(m => m.hostname == hostname);
            if (findindex != undefined) {
                findindex.urlconfig = urldst;
            }
        }
    }

    function OpenMonitorApp(idconfig: string) {
        console.log("idmonitor:" + idconfig);
        location.href = props.urlmonitor.replace("%idconfig%", idconfig);
    }

    const RegisterPC = async () => {
        console.log("RegisterPC");
        await signalrhub.invoke("RegisterPC");
    }

    const JoinGroupByUser = async () => {
        console.log("JoinGroupByUser");
        if (signalrhub != null) {
            await signalrhub.invoke("JoinGroupUser");
        }
    }

    async function LaunchDetection() {
        await LaunchDetectionAux(pccheck.value);
    }

    async function LaunchDetectionAux(hostname:string[]) {
        isdetect.value = false;
        const detectaction: DetectActionData = new DetectActionData();
        detectaction.hostname = hostname;
        console.log("LaunchDetection", hostname);
        detectaction.service = +(servicecurrent.value as number);
        const res: AxiosResponse<boolean> = await axios.post<boolean>("/api/v1.0/WebSocket/DetectConfig", detectaction);
        isdetect.value = true;
    }

    async function ChangeLangue(hostname:string,lan: string) {
        isdetect.value = true;
        const request: ChangeLangueActionData = new ChangeLangueActionData();
        request.hostname = hostname;
        request.lan = lan;
        const res: AxiosResponse<boolean> = await axios.post<boolean>("/api/v1.0/WebSocket/ChangeLangue", request);
        isdetect.value = false;
    }

    async function InstallDrivers(idconfig: number) {
        isdetect.value = false;
        const request: DriversInstallActionData = new DriversInstallActionData();
        request.hostname = pccheck.value;
        request.idconfig = idconfig;
        const res: AxiosResponse<boolean> = await axios.post<boolean>("/api/v1.0/WebSocket/InstallDrivers", request);
        isdetect.value = true;
    }

    async function CreateRestorePoint() {
        isdetect.value = false;
        const pointrestoreaction: RestorePointActionData = new RestorePointActionData();
        pointrestoreaction.hostname = pccheck.value;
        const res: AxiosResponse<boolean> = await axios.post<boolean>("/api/v1.0/WebSocket/CreateRestorePoint", pointrestoreaction);
        isdetect.value = true;
    }

    async function BackupAllDriver() {
        isdetect.value = false;
        const BackupAllDriveraction: BackupAllDriverActionData = new BackupAllDriverActionData();
        BackupAllDriveraction.hostname = pccheck.value;
        const res: AxiosResponse<boolean> = await axios.post<boolean>("/api/v1.0/WebSocket/BackupAllDriver", BackupAllDriveraction);
        isdetect.value = true;
    }

    async function StartMonitoring() {
        isdetect.value = false;
        const request: MonitoringActionData = new MonitoringActionData();
        request.hostname = pccheck.value;
        const res: AxiosResponse<boolean> = await axios.post<boolean>("/api/v1.0/WebSocket/StartMonitoring", request);
        isdetect.value = true;
    }

    async function StopMonitoring() {
        isdetect.value = false;
        const request: MonitoringActionData = new MonitoringActionData();
        request.hostname = pccheck.value;
        const res: AxiosResponse<boolean> = await axios.post<boolean>("/api/v1.0/WebSocket/StopMonitoring", request);
        isdetect.value = true;
    }

    const GetListeConnected = async () => {
        console.log("GetListeConnected");
        pccheck.value = [];
        listeconnected.value = [];
        const res: AxiosResponse<WebSocketIndex[]> = await axios.get<WebSocketIndex[]>("/api/v1.0/WebSocket/GetListeConnected");
        for (let pc of res.data) {
            console.log("GetListeConnected " + pc.hostname + " " + pc.isconnect);
            pc.isconnect = false;
        }
        listeconnected.value = res.data;
        await SendPongsAll();
    }

    async function SendPongsAll() {
        console.log("SendPongsAll");
        const res: AxiosResponse<void> = await axios.post<void>("/api/v1.0/WebSocket/SendPongsAll");
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (NumConfigConnected()>0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h5", null, _toDisplayString(_ctx.dcappcloud_desc), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkall).value = $event)),
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (SetCheckAll($event))),
                      type: "checkbox",
                      id: "checktous"
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelCheckbox, checkall.value]
                    ]),
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.dcappcloud_all), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checknone).value = $event)),
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (SetCheckNone($event))),
                      type: "checkbox",
                      id: "checkaucun"
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelCheckbox, checknone.value]
                    ]),
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.dcappcloud_none), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listeconnected.value, (pc) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (pc.isconnect)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                id: 'checkhost_'+pc.hostname,
                                disabled: _unref(isdetect),
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((pccheck).value = $event)),
                                value: pc.hostname
                              }, null, 8 /* PROPS */, _hoisted_15), [
                                [_vModelCheckbox, pccheck.value]
                              ]),
                              _createElementVNode("label", {
                                class: "form-check-label hostname",
                                for: 'checkhost_'+pc.hostname
                              }, _toDisplayString(pc.hostname), 9 /* TEXT, PROPS */, _hoisted_16)
                            ]),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.dcappcloud_installedagent) + " " + _toDisplayString(pc.versionagent), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", {
                                class: "progress-bar",
                                role: "progressbar",
                                style: _normalizeStyle({width:GetProgressPourcentage(pc.hostname)+'%'}),
                                "aria-valuenow": GetProgressPourcentage(pc.hostname),
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }, null, 12 /* STYLE, PROPS */, _hoisted_20)
                            ]),
                            (GetProgressDesc(pc.hostname))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(GetProgressDesc(pc.hostname)), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_22, [
                (actioncurrent.value==_unref(AppCloudAction).DetectConfig && !hasTerminateDetection.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-primary",
                      disabled: _unref(isdetect)||pccheck.value.length==0,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (LaunchDetection()))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-sync", {'fa-spin':_unref(isdetect)}])
                      }, null, 2 /* CLASS */),
                      _createTextVNode(_toDisplayString(_ctx.dcappcloud_but_startdetect), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_23))
                  : _createCommentVNode("v-if", true),
                (actioncurrent.value==_unref(AppCloudAction).DetectConfig && hasTerminateDetection.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-primary",
                      disabled: pccheck.value.length==0,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (TerminateDetection()))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-sync", {'fa-spin':_unref(isdetect)}])
                      }, null, 2 /* CLASS */),
                      _createTextVNode(_toDisplayString(_ctx.dcappcloud_but_terminatedetect), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_24))
                  : _createCommentVNode("v-if", true),
                (actioncurrent.value==_unref(AppCloudAction).DriversInstall)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "btn btn-primary",
                      disabled: _unref(isdetect)||pccheck.value.length==0,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (InstallDrivers(0)))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-sync", {'fa-spin':_unref(isdetect)}])
                      }, null, 2 /* CLASS */),
                      _createTextVNode(_toDisplayString(_ctx.dcappcloud_but_installdrivers), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_25))
                  : _createCommentVNode("v-if", true),
                (actioncurrent.value==_unref(AppCloudAction).RestorePoint)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "btn btn-primary",
                      disabled: _unref(isdetect)||pccheck.value.length==0,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (CreateRestorePoint()))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-sync", {'fa-spin':_unref(isdetect)}])
                      }, null, 2 /* CLASS */),
                      _createTextVNode(_toDisplayString(_ctx.dcappcloud_but_createrestorepoint), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_26))
                  : _createCommentVNode("v-if", true),
                (actioncurrent.value==_unref(AppCloudAction).BackupAllDriver)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      class: "btn btn-primary",
                      disabled: _unref(isdetect)||pccheck.value.length==0,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (BackupAllDriver()))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-sync", {'fa-spin':_unref(isdetect)}])
                      }, null, 2 /* CLASS */),
                      _createTextVNode(_toDisplayString(_ctx.dcappcloud_but_savealldrivers), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_27))
                  : _createCommentVNode("v-if", true),
                (actioncurrent.value==_unref(AppCloudAction).Monitoring)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      class: "btn btn-primary",
                      disabled: _unref(isdetect)||pccheck.value.length==0,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (StartMonitoring()))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-sync", {'fa-spin':_unref(isdetect)}])
                      }, null, 2 /* CLASS */),
                      _createTextVNode(_toDisplayString(_ctx.dcappcloud_but_startmonitoring), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_28))
                  : _createCommentVNode("v-if", true),
                (actioncurrent.value==_unref(AppCloudAction).Monitoring)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 6,
                      class: "btn btn-primary",
                      disabled: _unref(isdetect)||pccheck.value.length==0,
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (StopMonitoring()))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-sync", {'fa-spin':_unref(isdetect)}])
                      }, null, 2 /* CLASS */),
                      _createTextVNode(_toDisplayString(_ctx.dcappcloud_but_stopmonitoring), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_29))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", null, _toDisplayString(_ctx.dcappcloud_desc_connect), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("button", {
            id: "dcconnectbut",
            href: _unref(authuserurl),
            class: "btn btn-primary",
            disabled: _unref(authuserurl)=='',
            onClick: _cache[12] || (_cache[12] = ($event: any) => (DCConnect()))
          }, _toDisplayString(_ctx.dcappcloud_but_connect), 9 /* TEXT, PROPS */, _hoisted_31)
        ]),
        (isAgentInstalled.value==ProtocolHandlerStatus.NotInstalled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.dcappcloud_agent_errconnect_notinstalled), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        (isAgentInstalled.value==ProtocolHandlerStatus.NoSupport)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.dcappcloud_agent_errconnect_nosupport), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _hoisted_36,
        (listeconnected.value.length == 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (!_ctx.isconnect)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.dcappcloud_emptyconnectedlist_notconnect), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_ctx.isconnect)
                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.dcappcloud_emptyconnectedlist_connect), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (listeconnected.value.length > 0)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_39, _toDisplayString(_ctx.dcappcloud_listconnected), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (listeconnected.value.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_40, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listeconnected.value, (pc) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (!pc.isconnect)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, _toDisplayString(pc.hostname), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.dcappcloud_noinstalledagent), 1 /* TEXT */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}
}

})